<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="['App Versions', locationData.operatingSystem]"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="location-edit-operating-system">Operating System</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.operatingSystem"
                  name="operatingSystem"
                  #operatingSystem="ngModel"
                  class="form-control"
                  id="location-edit-operating-system"
                  required
                  readonly
                />
                <small class="text-danger" *ngIf="(operatingSystem.touched || operatingSystem.dirty) && !operatingSystem.valid">
                  Operating System is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="location-edit-current-version">Current Version</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="locationData.currentVersion"
                  name="currentVersion"
                  #currentVersion="ngModel"
                  class="form-control"
                  id="location-edit-current-version"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(currentVersion.touched || currentVersion.dirty) && !currentVersion.valid">
                  Current Version is invalid.
                </small>
              </div>

              <div class="form-group">
                <label for="location-edit-minimal-version">Minimal Version</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="locationData.minimalVersion"
                  name="minimalVersion"
                  #minimalVersion="ngModel"
                  class="form-control"
                  id="location-edit-minimal-version"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(minimalVersion.touched || minimalVersion.dirty) && !minimalVersion.valid">
                  Minimal Version is invalid.
                </small>
                <small class="text-danger"
                  *ngIf="(minimalVersion.touched
                  || minimalVersion.dirty
                  || currentVersion.touched
                  || currentVersion.dirty)
                  && minimalVersion.value > currentVersion.value">
                  Minimal Version must be greater than Current Version.
                </small>
              </div>

              <div class="form-group">
                <label for="location-edit-minimal-store-version">Current store version</label>
                <input
                  pattern="^[0-9]{1,2}([.][0-9]{1,2}[.][0-9]{1,2})?$"
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.currentStoreVersion"
                  name="currentStoreVersion"
                  #currentStoreVersion="ngModel"
                  class="form-control"
                  id="location-edit-client-version"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(currentStoreVersion.touched || currentStoreVersion.dirty) && !currentStoreVersion.valid">
                  Current store version is invalid. Тhe value should be in the following format X.X.X.
                </small>
              </div>

              <div class="form-group">
                <label for="location-edit-minimal-store-version">Minimal store version</label>
                <input
                  pattern="^[0-9]{1,2}([.][0-9]{1,2}[.][0-9]{1,2})?$"
                  type="text"
                  class="form-control"
                  [(ngModel)]="locationData.minimalStoreVersion"
                  name="minimalStoreVersion"
                  #minimalStoreVersion="ngModel"
                  class="form-control"
                  id="location-edit-client-version"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(minimalStoreVersion.touched || minimalStoreVersion.dirty) && !minimalStoreVersion.valid">
                  Minimal store version is invalid. Тhe value should be in the following format X.X.X.
                </small>
                <small class="text-danger"
                  *ngIf="(minimalStoreVersion.touched
                  || minimalStoreVersion.dirty
                  || currentStoreVersion.touched
                  || currentStoreVersion.dirty)
                  && minimalStoreVersion.value > currentStoreVersion.value">
                  Minimal store version must be greater than Current store version.
                </small>
              </div>

              <div style="margin-top: 40px;">
                <span class="btn-right">
                  <button
                  id='appVersionsCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button
                  id='appVersionsSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/app-versions/app-versions-edit/app-versions-edit.component.html